module.exports = __webpack_public_path__ + "img/coaching_3-sm.efc2142a.png";